module.exports = __webpack_public_path__ + "img/YE.efd1cd0a.svg";